export function CutString(str, ind){
    return str.length > ind ? str.substring(0,ind)+'...': str;
}